/**
 * Назва маршруту, на якому зараз людина, — для журналу змін: кожен запит до
 * API несе її в заголовку `x-ugi-screen`, і рядок журналу каже не лише
 * «DeleteDocument», а й з якого екрана.
 *
 * Окремий модуль, а не імпорт роутера в лінки Apollo: роутер тягне сторінки,
 * а сторінки — клієнт Apollo.
 */
let currentScreen: string | undefined;

export const setCurrentScreen = (name: string | undefined): void => {
  currentScreen = name;
};

export const getCurrentScreen = (): string | undefined => currentScreen;
